"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTP001_Regist = void 0;
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const common_1 = require("../../../common");
const react_redux_1 = require("react-redux");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const classes_1 = require("../../base/classes");
const server_1 = require("../../../server");
const layout_1 = require("../../base/layout");
const SurveyContainer_1 = require("../../base/layout/Survey/SurveyContainer");
const DSTP001_Regist_Child_1 = require("./component/DSTP001_Regist_Child");
const TestSubTypeManager_1 = require("./component/DSTP001_Regist_Child/TestSubTypeManager");
const PublicChoiceBox_1 = require("./component/DSTP001_Regist_Child/PublicChoiceBox");
const constant_1 = require("./constant");
const function_1 = require("./function");
const DSTL001_List_Child_1 = require("./component/DSTL001_List_Child");
const popup_1 = require("../../base/popup");
// 출제 유형 - 기본 값
const default_questionType = { id: 'select', title: 'common.select' };
const fixed_survey_questionType = { id: 'survey', title: 'assignment.survey' };
// 테스트 유형 - 기본 값
const default_testType = { id: 'select', title: 'common.select' };
const gmk_testType = { id: 'gmk', title: 'assignment.gmk' };
const yigam_testType = { id: 'yigam', title: 'assignment.yigam' };
const etc_testType = { id: 'etc', title: 'assignment.etc' };
exports.DSTP001_Regist = react_1.default.memo(({ id, isBackOffice = false, isTest = false, isReserve = false, setUpdateCheckList, onDeferredTest, isTeacher, isModify, isLive = false, isPopup = false, isSurvey = false, conferenceStart, conferenceEnd, }) => {
    const [t] = (0, react_i18next_1.useTranslation)();
    const { classesId, isTablet, isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const classSubject = (0, react_redux_1.useSelector)((state) => (0, classes_1.getClasses)(state)?.subject);
    const [className, setClassName] = (0, react_1.useState)(''); // 수업명
    const [assignmentName, setAssignmentName] = (0, react_1.useState)(''); // 과제명 or 테스트 명
    const [classId, setClassId] = (0, react_1.useState)(''); // 반 id
    const [startDate, setStartDate] = (0, react_1.useState)(''); // 시작일
    const [startTime, setStartTime] = (0, react_1.useState)(''); // 시작 시간
    const [endDate, setEndDate] = (0, react_1.useState)(''); // 마감일
    const [endTime, setEndTime] = (0, react_1.useState)(''); // 마감 시간
    const [duration, setDuration] = (0, react_1.useState)(''); // 시험 시간
    const [questionType, setQuestionType] = (0, react_1.useState)(isSurvey ? fixed_survey_questionType : default_questionType); // 출제 유형
    const [testType, setTestType] = (0, react_1.useState)(default_testType); // 테스트 유형
    const [round, setRound] = (0, react_1.useState)(''); // 회차
    const [gradeReport, setGradeReport] = (0, react_1.useState)(true); // 회차별 성적 포함 여부 (기타 유형)
    const [reportName, setReportName] = (0, react_1.useState)(''); // 성적표명(비기본형) — subject 필드로 전송
    const [subTypeId, setSubTypeId] = (0, react_1.useState)(''); // 상세 유형 ID (기타 유형)
    // 상세 유형 관리 팝업을 전역 팝업(단일 슬롯)으로 열면 테스트 등록 팝업이 슬롯에서 교체·언마운트되어
    // 닫을 때 등록 팝업까지 사라지고 입력값이 소실된다. → 이 컴포넌트 내부 오버레이로 띄워
    // 등록 팝업이 마운트된 채 유지되도록 한다(닫으면 오버레이만 닫히고 등록 입력값은 보존).
    const [showSubTypeManager, setShowSubTypeManager] = (0, react_1.useState)(false);
    const [originalQuestionType, setOriginalQuestionType] = (0, react_1.useState)(questionType); // 출제 유형
    const [subject, setSubject] = (0, react_1.useState)(undefined); // 과목
    const [originalSubject, setOriginalSubject] = (0, react_1.useState)(constant_1.default_subject); // 과목
    const [evalList, setEvalList] = (0, react_1.useState)([]); // 평가 항목
    const [scoreBlank, setScoreBlank] = (0, react_1.useState)(false); // 전체 공백점수
    const [evalItemCnt, setEvalItemCnt] = (0, react_1.useState)(0); // 평가 항목 개수
    const [attachFileList, setAttachFileList] = (0, react_1.useState)([]); // 첨부파일
    const [initEvalData, setInitEvalData] = (0, react_1.useState)([]); // 초기 설정 값을 위한 값 (re render 방지)
    const [evalData, setEvalData] = (0, react_1.useState)(initEvalData); // 평가 항목 데이터
    const [surveyData, setSurveyData] = (0, react_1.useState)([]); // 설문 데이터
    const [checkSubjectList, setCheckSubjectList] = (0, react_1.useState)([]); // 과목 선택 리스트
    const [load, setLoad] = (0, react_1.useState)(false); // 데이터 로드 여부
    const [hide, setHide] = (0, react_1.useState)(false); // 공개 여부
    const [item, setItem] = (0, react_1.useState)(undefined); // 선택된 항목
    const [mobilePage, setMobilePage] = (0, react_1.useState)(0);
    const [dataId, setDataId] = (0, react_1.useState)(id); // 데이터 id
    const [fromBackOffice, setFromBackOffice] = (0, react_1.useState)(false); // 백오피스에서 불러온 경우우
    const deleteMutation = (0, react_query_1.useMutation)(server_1.deleteAssignmentList);
    const fileMutation = (0, react_query_1.useMutation)(server_1.postFile);
    const assignmentMutation = (0, react_query_1.useMutation)(server_1.postAssignmentList);
    const updateAssignmentMutation = (0, react_query_1.useMutation)(server_1.postUpdateAssignmentList);
    const questionMutation = (0, react_query_1.useMutation)(server_1.postQuestion);
    // 과제 데이터 불러오기
    const { data, refetch } = (0, server_1.useAssignmentList)({
        id: dataId,
        // 편집(dataId 존재)은 id 로 단건 조회하므로 survey 필터를 걸지 않는다.
        // (설문조사 출제유형 = survey:true 로 저장된 테스트를 강의등록/테스트 편집에서 불러올 때
        //  survey:false 필터에 걸려 누락되는 것을 방지. 전용 설문조사 메뉴 isSurvey 흐름은 기존대로 유지)
        ...(!(isBackOffice || fromBackOffice) && (isSurvey || !dataId) ? { survey: isSurvey } : {}),
        ...(isBackOffice || fromBackOffice ? { back_office: true } : { class_id: classesId }),
    });
    // 질문 데이터 불러오기
    const { data: questionData, refetch: questionReftch } = (0, server_1.useQuestionList)({
        test_id: dataId,
    });
    // 상세 유형 목록 (기타 유형 선택 시 사용)
    const { data: subTypesData, refetch: refetchSubTypes } = (0, server_1.useSubTypes)();
    // 선택한 수업(강의) 정보 — 테스트 시작/종료일시 기본값 및 범위 검증에 사용
    const { data: conferenceListData, refetch: refetchConferenceList } = (0, server_1.useConferenceList)({
        status: 'booked',
    });
    (0, react_1.useEffect)(() => {
        if (isTest && !isReserve && !isBackOffice)
            refetchConferenceList();
    }, []);
    const conferenceRange = (0, react_1.useMemo)(() => {
        // 예약 모드: 아직 저장되지 않은 강의의 시작/종료일시를 props로 직접 전달받아 사용한다.
        if (isReserve && conferenceStart) {
            const start = (0, moment_1.default)(conferenceStart);
            if (!start.isValid())
                return null;
            const end = conferenceEnd && (0, moment_1.default)(conferenceEnd).isValid()
                ? (0, moment_1.default)(conferenceEnd)
                : null;
            return end ? { start, end } : null;
        }
        const conf = (conferenceListData?.items || []).find((c) => c.id === classId);
        if (!conf?.start_time)
            return null;
        const start = (0, moment_1.default)(conf.start_time);
        const end = conf.end_time
            ? (0, moment_1.default)(conf.end_time)
            : start.clone().add(Number(conf.progress_duration) || 0, 'minutes');
        return { start, end };
    }, [conferenceListData, classId, isReserve, conferenceStart, conferenceEnd]);
    // 새 테스트 등록 시: 수업(강의)을 선택하면 시작/종료일시 기본값을 수업 시작/종료일시로 설정
    (0, react_1.useEffect)(() => {
        if (id)
            return; // 편집은 저장된 값 유지
        if (!isTest || isBackOffice)
            return;
        if (!conferenceRange)
            return;
        setStartDate(conferenceRange.start.format('YYYY-MM-DD'));
        setStartTime(conferenceRange.start.format('HH:mm'));
        setEndDate(conferenceRange.end.format('YYYY-MM-DD'));
        setEndTime(conferenceRange.end.format('HH:mm'));
    }, [conferenceRange, id, isTest, isReserve, isBackOffice]);
    (0, react_1.useEffect)(() => {
        refetchSubTypes();
    }, []);
    (0, react_1.useEffect)(() => {
        if (!dataId) {
            setItem(undefined);
            setAssignmentName('');
            setClassId('');
            setClassName('');
            // 예약 모드에서 강의 시작/종료일시가 전달되면 그 범위를 기본값으로 사용,
            // 아니면 현재 시각을 기본값으로 사용한다.
            const defaultStart = isReserve && conferenceRange ? conferenceRange.start : (0, moment_1.default)();
            const defaultEnd = isReserve && conferenceRange ? conferenceRange.end : (0, moment_1.default)();
            setStartDate(defaultStart.format('YYYY-MM-DD'));
            setStartTime(defaultStart.format('HH:mm'));
            setEndDate(defaultEnd.format('YYYY-MM-DD'));
            setEndTime(defaultEnd.format('HH:mm'));
            setQuestionType(isSurvey ? fixed_survey_questionType : default_questionType);
            setTestType(default_testType);
            setRound('');
            setGradeReport(true);
            setSubTypeId('');
            setAttachFileList([]);
            setSubject(constant_1.default_subject);
            setHide(false);
            setOriginalQuestionType(isSurvey ? fixed_survey_questionType : default_questionType);
            setOriginalSubject(constant_1.default_subject);
            setLoad(true);
            return;
        }
        refetch();
        questionReftch();
    }, [dataId, isSurvey]);
    // 과제 데이터 불러오기 - 초기 값 설정
    (0, react_1.useEffect)(() => {
        if (!data || !dataId)
            return;
        const { found_count, items } = data;
        if (found_count > 0) {
            const item = items[0];
            setItem(item);
            setAssignmentName(item.title);
            item.conference_id && item.conference_id.length > 0 && setClassId(item.conference_id);
            item.conference_name && item.conference_name.length > 0 && setClassName(item.conference_name);
            setStartDate((0, moment_1.default)(fromBackOffice ? undefined : item.startline).format('YYYY-MM-DD'));
            setStartTime((0, moment_1.default)(fromBackOffice ? undefined : item.startline).format('HH:mm'));
            setEndDate((0, moment_1.default)(fromBackOffice ? undefined : item.deadline).format('YYYY-MM-DD'));
            setEndTime((0, moment_1.default)(fromBackOffice ? undefined : item.deadline).format('HH:mm'));
            setDuration(item.duration);
            if (isTest) {
                if (item.report_type === 'gmk')
                    setTestType(gmk_testType);
                else if (item.report_type === 'yigam')
                    setTestType(yigam_testType);
                else if (item.report_type === 'etc')
                    setTestType(etc_testType);
                else
                    setTestType(default_testType);
                setRound(item.round ? String(item.round) : '');
                setGradeReport(item.grade_report !== false);
            }
            // 편집 복원: 전용 설문조사 메뉴(isSurvey)는 'survey'(설문형) 고정.
            // 그 외 컨텍스트에서 survey:true 로 저장된 항목은 출제유형 '설문조사'(survey-poll)로 복원한다.
            // (설문형/설문조사 모두 서버 type 은 '설문형'이라 item.type 만으로는 구분 불가 → item.survey 로 구분)
            const questionType = isSurvey
                ? 'survey'
                : item.survey === true
                    ? 'survey-poll'
                    : (0, function_1.getQuestionType)(item.type);
            setQuestionType({ id: questionType, title: `assignment.${questionType}` });
            setOriginalQuestionType({ id: questionType, title: `assignment.${questionType}` });
            setAttachFileList(item.attachments);
            setSubject(questionType === 'OMR'
                ? { id: item.subject, title: `assignment.${item.subject}` }
                : constant_1.default_subject);
            setOriginalSubject({ id: item.subject, title: `assignment.${item.subject}` });
            // 비기본형은 subject 필드에 성적표명을 저장하므로, 편집 시 item.subject 에서 성적표명 input 복원
            // ('select'는 과거 미선택 잔재이므로 빈값 처리)
            setReportName(questionType !== 'OMR' && item.subject !== 'select' ? (item.subject || '') : '');
            setHide(item.status === 'hide' ? true : false);
            setLoad(true);
        }
    }, [data, isSurvey]);
    // 현재 질문에 선택된 평가항목 기본값 설정
    (0, react_1.useEffect)(() => {
        if (!questionData)
            return;
        const { total_count, items } = questionData;
        if (total_count > 0) {
            // 중복 제거된 evalList 생성
            const evalList = items
                .map(item => item.subject_item)
                .reduce((acc, current) => {
                const isDuplicate = acc.find(item => item === current);
                if (!isDuplicate) {
                    acc.push(current);
                }
                return acc;
            }, []);
            setCheckSubjectList(evalList); // 중복이 제거된 evalList 상태로 설정
        }
    }, [questionData]);
    // 평가 항목 데이터 불러오기 - 초기 값 설정
    (0, react_1.useEffect)(() => {
        if (questionData) {
            let originEvalData = [];
            const { total_count, items } = questionData;
            if (total_count > 0) {
                items?.forEach(item => {
                    const evalTableProps = {
                        id: item.number,
                        type: item.type,
                        score: item.point,
                        answer: item.answer,
                        examples: item.examples,
                    };
                    const existingDataIndex = originEvalData.findIndex(dataItem => dataItem.key === item.subject_item);
                    if (existingDataIndex !== -1) {
                        // Append evalTableProps to the existing array
                        originEvalData[existingDataIndex].data = [
                            ...originEvalData[existingDataIndex].data,
                            evalTableProps,
                        ];
                    }
                    else {
                        // Add new entry if subject_item is not in data
                        originEvalData.push({
                            key: item.subject_item,
                            data: [evalTableProps],
                        });
                    }
                });
            }
            if (questionType.id === 'OMR-free') {
                setEvalItemCnt(originEvalData.length);
            }
            // Update initEvalData without duplicate updates
            if (JSON.stringify(initEvalData) !== JSON.stringify(originEvalData)) {
                setInitEvalData(originEvalData);
            }
        }
    }, [questionData, originalQuestionType, originalSubject]);
    // 평가 항목 데이터 불러오기 ( 자유형일때 세팅 , 기본형은 SubjectTypeDetail.tsx에서 세팅 )
    (0, react_1.useEffect)(() => {
        if (item?.type === 'OMR (자유형)' && originalQuestionType.id === questionType.id) {
            let evalList = [];
            checkSubjectList.map((item, index) => {
                evalList.push({
                    id: item,
                    title: item,
                    checked: true,
                });
            });
            setEvalList(evalList);
        }
    }, [item?.type, questionType, checkSubjectList]);
    // 평가 항목 데이터 불러오기 - 과목 및 평가 항목 변경 시
    (0, react_1.useEffect)(() => {
        let data = [];
        evalList?.forEach(evalItem => {
            if (evalItem.checked) {
                const isExistevalData = evalData.find(dataItem => dataItem.key === evalItem.title)
                    ? evalData.find(dataItem => dataItem.key === evalItem.title)
                    : originalQuestionType.id === questionType.id
                        ? initEvalData.find(item => item.key === evalItem.title)
                        : undefined;
                if (isExistevalData) {
                    // 수정된 데이터를 evalData에 적용
                    data.push(isExistevalData);
                }
                else {
                    const defaultScore = (0, function_1.getDefaultScore)(subject.id, evalItem.title);
                    const newData = (0, function_1.createEvalArray)(defaultScore, scoreBlank);
                    data.push({ data: newData, key: evalItem.title });
                }
            }
        });
        const test = (0, function_1.ensureUniqueKeys)(data);
        data = test
            .filter(item => {
            return evalList?.some(i => i.checked && item.key === i.title);
        })
            .map(item => {
            return {
                ...item,
                data: item.data
                    .map(i => {
                    return {
                        ...i,
                        score: scoreBlank ? 0 : i.score,
                    };
                })
                    .sort((a, b) => a.id - b.id),
            };
        })
            .sort((a, b) => {
            const subjectOrder = [
                '공통',
                '선택 - 언어와매체',
                '선택 - 화법과 작문',
                '듣기',
                '읽기',
                '선택 - 미적분',
                '선택 - 확률과 통계',
                '선택 - 기하',
            ];
            return (
            // @ts-ignore
            subjectOrder.indexOf(a.key) - subjectOrder.indexOf(b.key));
        });
        if (questionType.id === 'OMR-free') {
            setEvalItemCnt(data.length);
        }
        if (lodash_1.default.isEqual(data, evalData))
            return;
        setEvalData(data);
    }, [evalList, questionType, subject?.id, initEvalData]);
    /**
     *
     * 출제 유형이 변경되는 경우
     *
     * OMR  -> 1. 과목 선택 생성
     *      -> 2. 평가 항목 초기화
     *
     * other -> 1. 과목 선택 제거
     *          -> 2. 평가 항목 초기화
     */
    (0, react_1.useEffect)(() => {
        if (dataId && !item)
            return;
        if (questionType?.id === originalQuestionType?.id) {
            if (dataId) {
                if (subject?.id === originalSubject?.id) {
                    setAttachFileList(item?.attachments || []);
                    setSubject({ id: item.subject, title: `assignment.${item.subject}` });
                }
            }
            else {
                if (questionType.id === 'OMR') {
                    setSubject(constant_1.default_subject);
                }
                if (questionType.id === 'OMR-free')
                    setSubject({ id: 'select', title: 'assignment.select' });
            }
        }
        else {
            setEvalData([]);
            setEvalList([]);
            setEvalItemCnt(0);
        }
    }, [
        item?.attachments,
        questionType?.id,
        subject?.id,
        originalSubject?.id,
        originalQuestionType?.id,
    ]);
    (0, react_1.useEffect)(() => {
        setEvalData((prevData) => {
            // 변경된 데이터를 만듭니다.
            const newData = prevData.map(item => {
                return {
                    ...item,
                    data: item.data.map(i => {
                        // 점수가 0점인 경우 기본값을 찾습니다.
                        if (!scoreBlank) {
                            const scoreTest = (0, function_1.getDefaultScore)(subject.id, item.key);
                            const newData = (0, function_1.createEvalArray)(scoreTest, scoreBlank);
                            const test = newData.find(j => j.id === i.id) || {};
                            return {
                                ...i,
                                score: scoreBlank ? 0 : test?.score,
                            };
                        }
                        return {
                            ...i,
                            score: scoreBlank ? 0 : i.score,
                        };
                    }),
                };
            });
            return newData;
        });
    }, [scoreBlank]);
    const setDataFromBackOffice = (item) => {
        setFromBackOffice(true);
        setDataId(item[0]);
    };
    // (onClick) 과제 불러오기
    const loadAssignmentName = () => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DSTL001_List_Child_1.AssignmentTable,
            componentProps: {
                isTest: isTest,
                isSurvey: isSurvey,
                isTeacher: true,
                isBackOffice: true,
                isReserve: true,
                setUpdateCheckList: setDataFromBackOffice,
            },
            width: 757,
            title: t(`conference.${isSurvey ? 'surveyDownload' : isTest ? 'testDownload' : 'assignmentDownload'}`),
        });
    };
    // (onClick) 바로 시작하기
    const updateStartNow = (changeDate) => {
        if (changeDate === true) {
            const now = (0, moment_1.default)().add(3, 'minutes');
            const endDate = (0, moment_1.default)(now).add(7, 'days');
            setStartDate(now.format('YYYY-MM-DD'));
            setStartTime(now.format('HH:mm'));
            setEndDate(endDate.format('YYYY-MM-DD'));
            setEndTime(endDate.format('HH:mm'));
        }
        else {
            setStartDate('');
            setStartTime('');
            setEndDate('');
            setEndTime('');
        }
    };
    // (onClick) 과제 제출
    const submitAssignment = async (index) => {
        let test = [];
        APP.eventManager.publish('SHOW_LOADING', true);
        APP.eventManager.publish('CHECK_ERROR');
        try {
            // 1. 과제 제목이 없는 경우 에러 처리
            if (index === undefined
                ? !assignmentName ||
                    assignmentName === '' ||
                    assignmentName.trim().length === 0
                : (index >= 0 && !assignmentName) ||
                    assignmentName === '' ||
                    assignmentName.trim().length === 0) {
                throw new Error(t('error.noAssignmentName', {
                    name: isSurvey || questionType.id === 'survey-poll'
                        ? t('assignment.surveyName')
                        : isTest
                            ? t('assignment.testname')
                            : t('assignment.subjectName'),
                }));
            }
            // 테스트 등록인 경우 강의 선택 필수
            if (!isBackOffice && !isReserve && isTest && (classId === 'select' || classId.trim() === '')) {
                throw new Error(t('error.noClass'));
            }
            // 1. 시작일 또는 시간이 없는지 확인 (테스트는 시작일 input 없음 → 검증 제외)
            const checkStart = !isTest && (!startDate || !startTime);
            if (index === undefined ? checkStart : index >= 0 && checkStart) {
                throw new Error(t('error.noStartDate'));
            }
            // 2. 마감일 또는 시간이 없는지 확인 (테스트는 마감일 input 없음 → 검증 제외)
            const checkEnd = !isTest && (!endDate || !endTime);
            if (index === undefined ? checkEnd : index >= 0 && checkEnd) {
                throw new Error(t('error.noEndDate'));
            }
            // 미리 moment 객체를 생성하여 반복되는 작업 제거
            const startDateTime = (0, moment_1.default)(`${startDate} ${startTime}`);
            const endDateTime = (0, moment_1.default)(`${endDate} ${endTime}`);
            // 3. 시작일이 현재 시간보다 이전인지 확인
            const isCheckStartTime = !isTest && !isBackOffice && startDateTime.isBefore((0, moment_1.default)());
            if (index === undefined ? isCheckStartTime : index >= 0 && isCheckStartTime) {
                throw new Error(t('error.lateNow'));
            }
            const isCheckTestStartTime = isTest && !isBackOffice && startDateTime.isBefore((0, moment_1.default)().startOf('day'));
            if (index === undefined ? isCheckTestStartTime : index >= 0 && isCheckTestStartTime) {
                throw new Error(t('error.lateNow'));
            }
            // 4. 시작일이 마감일보다 늦은지 확인
            const isCheckEndTime = !isTest && !isBackOffice && startDateTime.isAfter(endDateTime);
            if (index === undefined ? isCheckEndTime : index >= 0 && isCheckEndTime) {
                throw new Error(t('error.lateEnd'));
            }
            // (p.8 이전 복원) p.8에서 추가됐던 '강의 시간범위' 검증 제거
            // 5. 테스트 모드일때, 풀이 시간이 0보다 커야함 (0분 이상)
            const isCheckDuration = isTest && !isNaN(Number(duration)) && Number(duration) < 1;
            if (index === undefined ? isCheckDuration : index >= 0 && isCheckDuration) {
                throw new Error(t('error.noDuration'));
            }
            // (p.8 이전 복원) p.8에서 추가됐던 '풀이시간 ≤ 진행기간' 검증 제거
            // 6. 출제유형 선택 여부 확인
            if (!isSurvey &&
                (index === undefined
                    ? questionType.id === 'select'
                    : index >= 0 && questionType.id === 'select')) {
                throw new Error('출제 유형을 선택해주세요');
            }
            // 7. 과목 선택 여부 확인 — 기본형만 과목 필수(비기본형은 성적표명을 subject로 보내며 필수 아님)
            const isChoiceSubject = questionType.id === 'OMR' && subject.id === 'select';
            if (index === undefined ? isChoiceSubject : index >= 1 && isChoiceSubject) {
                throw new Error('과목을 선택해주세요');
            }
            // 설문, 첨부 파일, OMR 데이터를 검증하는 함수 호출
            if (index >= 1 || index === undefined) {
                if (['survey', 'survey-poll'].includes(questionType.id)) {
                    test = await (0, function_1.checkSurveyData)(surveyData);
                }
                else if (questionType.id === 'attachment') {
                    test = (0, function_1.checkAttachmentData)(assignmentName, attachFileList);
                }
                else {
                    // 평가 항목 등록 여부 확인
                    if (!evalData || evalData.length === 0)
                        throw new Error('평가 항목은 한문제 이상 등록되어야합니다');
                    else if (index === undefined)
                        test = (0, function_1.checkOMRData)(evalData, subject);
                }
            }
            if (index === undefined) {
                // 평가 항목 검증
                if (test.length === 0) {
                    throw new Error('평가 항목은 한문제 이상 등록되어야합니다');
                }
                let convertAttachFileList = [];
                // 첨부 파일이 있는 경우
                if (attachFileList && attachFileList.length > 0) {
                    try {
                        const alredyFile = attachFileList.filter(file => typeof file === 'string');
                        const filterFile = attachFileList.filter(file => file instanceof File);
                        // 첨부 파일 업로드를 비동기로 실행하고 완료될 때까지 기다립니다.
                        if (filterFile && filterFile.length > 0) {
                            const data = await fileMutation.mutateAsync(filterFile);
                            convertAttachFileList = [...data.result.link, ...alredyFile];
                        }
                        else {
                            convertAttachFileList = alredyFile;
                        }
                    }
                    catch (error) {
                        console.error('Failed to upload files:', error);
                        return; // 에러가 발생하면 함수를 종료합니다.
                    }
                }
                // 제출할 데이터를 구성합니다/
                // 출제유형 '설문조사'(survey-poll)는 테스트로 저장하되 survey:true 로 표시한다.
                // type 은 '설문형'으로 통일 → meetmate 무채점 응시/제출 로직을 그대로 재사용하고,
                // 설문형/설문조사 구분은 survey 불리언으로만 한다(서버 가이드: test.survey 활용).
                const surveyPayload = isSurvey
                    ? {
                        assignment: true,
                        survey: true,
                        type: t('assignment.survey'),
                    }
                    : questionType.id === 'survey-poll'
                        ? {
                            assignment: !isTest,
                            survey: true,
                            type: t('assignment.survey'),
                        }
                        : {
                            assignment: !isTest,
                            survey: false,
                            type: t(`assignment.${questionType.id}`),
                        };
                const data = {
                    ...surveyPayload,
                    attachments: convertAttachFileList,
                    duration: isTest ? Number(duration) : undefined,
                    // 설문조사(survey-poll)는 테스트 유형을 '기타'(etc)로 고정 저장(UI 미노출).
                    ...(isTest && questionType.id === 'survey-poll' ? {
                        report_type: 'etc',
                        round: 0,
                        grade_report: gradeReport,
                    } : isTest && testType.id !== 'select' ? {
                        report_type: testType.id,
                        round: round ? Number(round) : undefined,
                        ...(testType.id === 'etc' ? { grade_report: gradeReport } : {}),
                    } : {
                        report_type: '',
                        round: 0,
                    }),
                    ...(isBackOffice
                        ? {}
                        : {
                            // 테스트: 일반은 startline·deadline 생략(서버 처리), 강의등록(isReserve)은 강의 시작/종료로 채움(connect가 최종 동기화). 과제는 입력값.
                            ...(isTest
                                ? isReserve
                                    ? {
                                        ...(conferenceStart && (0, moment_1.default)(conferenceStart).isValid()
                                            ? { startline: (0, moment_1.default)(conferenceStart).format('YYYY-MM-DDTHH:mm:ssZ') }
                                            : {}),
                                        ...(conferenceEnd && (0, moment_1.default)(conferenceEnd).isValid()
                                            ? { deadline: (0, moment_1.default)(conferenceEnd).format('YYYY-MM-DDTHH:mm:ssZ') }
                                            : {}),
                                    }
                                    : {}
                                : {
                                    deadline: (0, moment_1.default)(`${endDate} ${endTime}`).format('YYYY-MM-DDTHH:mm:ssZ'),
                                    startline: (0, moment_1.default)(`${startDate} ${startTime}`).format('YYYY-MM-DDTHH:mm:ssZ'),
                                }),
                            class_id: classesId,
                        }),
                    title: assignmentName.trim(),
                    // 기본형은 선택 과목, 비기본형은 성적표명을 subject 필드로 전송(미작성 시 빈값)
                    subject: questionType.id === 'OMR' ? subject.id : reportName || '',
                    ...(isTest
                        ? {
                            conference_id: isTest
                                ? isReserve || (classId && classId === 'select')
                                    ? ''
                                    : classId
                                : '',
                        }
                        : {}),
                    back_office: isBackOffice,
                    ...(isBackOffice ? { hide } : {}),
                };
                // [지연 생성] 예약 모드(isReserve) + onDeferredTest 콜백이 있으면 즉시 생성하지 않는다.
                // 검증·파일업로드·payload(data)·질문배열(test)까지는 이 시점에 완료했으므로 사용자 피드백은 즉시.
                // 실제 create/sub_type/question API 는 강의 등록 성공 후 부모(DSTT001)가 수행한다.
                // (신규 생성 케이스에만 적용 — id 가 있으면 편집이므로 기존 즉시 경로 유지)
                if (isReserve && onDeferredTest && !id) {
                    onDeferredTest({
                        data,
                        questions: test,
                        subTypeId: testType.id === 'etc' && subTypeId && subTypeId !== 'select'
                            ? subTypeId
                            : '',
                        tempId: `pending_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
                        title: data.title || assignmentName.trim(),
                    });
                    if (isPopup) {
                        cancelPopup();
                    }
                    return;
                }
                // 과제 등록을 비동기로 실행하고 완료될 때까지 기다립니다.
                let assignmentId = undefined;
                if (id) {
                    const responseData = await updateAssignmentMutation.mutateAsync({
                        id,
                        props: data,
                    });
                    assignmentId = id;
                }
                else {
                    const responseData = await assignmentMutation.mutateAsync(data);
                    assignmentId = responseData.result.id;
                }
                // 상세 유형(sub_type)은 선택 필수가 아님 — 미선택('select'/빈값)이면 빈 값으로 전송(미지정/해제).
                // 서버가 빈값을 거부하더라도 테스트 저장 자체는 유지되도록 try/catch 로 격리.
                if (testType.id === 'etc' && assignmentId) {
                    try {
                        await (0, server_1.setTestSubType)(assignmentId, subTypeId && subTypeId !== 'select' ? subTypeId : '');
                    }
                    catch (e) {
                        console.warn('[DSTP001] setTestSubType (optional sub_type) failed:', e);
                    }
                }
                if (assignmentId) {
                    try {
                        await questionMutation.mutateAsync({
                            id: assignmentId,
                            props: test,
                        });
                        if (isReserve) {
                            // @ts-ignore
                            setUpdateCheckList((prevCheckList) => {
                                return [...prevCheckList, assignmentId];
                            });
                        }
                        else {
                            // 성공적으로 질문 데이터를 등록하면 이벤트를 발행하고 팝업을 취소합니다.
                            APP.eventManager.publish(constant_1.REFRESH_ASSIGNMENT_LIST);
                        }
                    }
                    catch {
                        if (!id) {
                            await deleteMutation.mutateAsync(id);
                        }
                        else {
                            // 제출할 데이터를 구성합니다/
                            const rollbackSurveyPayload = isSurvey
                                ? {
                                    assignment: true,
                                    survey: true,
                                }
                                : questionType.id === 'survey-poll'
                                    ? {
                                        assignment: !isTest,
                                        survey: true,
                                    }
                                    : {
                                        assignment: !isTest,
                                        survey: false,
                                    };
                            const data = {
                                ...rollbackSurveyPayload,
                                attachments: item.attachments,
                                duration: item.duration,
                                // 설문조사(survey-poll)는 테스트 유형을 '기타'(etc)로 고정(UI 미노출).
                                ...(isTest && questionType.id === 'survey-poll' ? {
                                    report_type: 'etc',
                                    round: 0,
                                    grade_report: gradeReport,
                                } : isTest && testType.id !== 'select' ? {
                                    report_type: testType.id,
                                    round: round ? Number(round) : undefined,
                                    ...(testType.id === 'etc' ? { grade_report: gradeReport } : {}),
                                } : {
                                    report_type: '',
                                    round: 0,
                                }),
                                ...(isBackOffice
                                    ? {}
                                    : {
                                        deadline: (0, moment_1.default)(item.deadline).format('YYYY-MM-DDTHH:mm:ssZ'),
                                        startline: (0, moment_1.default)(item.startline).format('YYYY-MM-DDTHH:mm:ssZ'),
                                        class_id: classesId,
                                    }),
                                title: item.title.trim(),
                                type: item.type,
                                subject: item.subject,
                                ...(isTest
                                    ? {
                                        conference_id: item.conference_id,
                                    }
                                    : {}),
                                back_office: isBackOffice,
                                ...(isBackOffice ? { hide } : {}),
                            };
                            await updateAssignmentMutation.mutateAsync({
                                id,
                                props: data,
                            });
                        }
                    }
                    finally {
                        if (isPopup) {
                            cancelPopup();
                        }
                        else {
                            APP.eventManager.publish('UPDATE_DETAIL_MENU', {
                                menuDetail: 'list',
                                id: undefined,
                            });
                            if (isBackOffice) {
                                APP.eventManager.publish('CHANGE_MENU', {
                                    showDepth: 'list',
                                    props: {},
                                });
                            }
                        }
                    }
                }
            }
            else {
                setMobilePage(mobilePage + 1);
            }
        }
        catch (err) {
            if (err === '진행 예정이 아닌 설문입니다.') {
                alert(t('error.alreadyStart'));
                APP.eventManager.publish(constant_1.REFRESH_ASSIGNMENT_LIST);
            }
            else {
                let errorMessage = err.message ? err.message : err;
                let cleanedMessage = errorMessage.replace('Error: ', '');
                alert(cleanedMessage);
            }
        }
        finally {
            APP.eventManager.publish('SHOW_LOADING', false);
        }
    };
    /**
     * Render 출제 유형
     * (과제명, 반, 시작일, 마감일, 시험 시간)
     */
    const renderAssignmentInfo = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { key: "assignmentInfo", className: "assignment-info-wrap" },
        isTest && !isReserve && !isBackOffice && (react_1.default.createElement(DSTP001_Regist_Child_1.ClassNameDropDown, { defaultClassId: item?.conference_id, classId: classId, className: className, setClassId: setClassId })),
        react_1.default.createElement("div", { className: "field-global-001" },
            react_1.default.createElement("div", { className: "task-label" }, isSurvey || questionType.id === 'survey-poll'
                ? t('assignment.surveyName')
                : isTest
                    ? t('assignment.testname')
                    : t('assignment.subjectName')),
            react_1.default.createElement("div", { className: "fext-field" },
                react_1.default.createElement(common_1.InputElement, { type: "text", value: assignmentName, onChange: setAssignmentName, max: 500 }),
                !isModify && !isBackOffice && !isReserve && (react_1.default.createElement(common_1.Button, { className: "btn_tur xmd", onClick: loadAssignmentName, text: "common.load" })))),
        isTest && questionType.id !== 'survey-poll' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "field-global-001" },
                react_1.default.createElement("div", { className: "task-label" }, t('conference.testType')),
                react_1.default.createElement("div", { className: "fext-field" },
                    react_1.default.createElement(common_1.DropDown, { className: "dropdown-popup", value: testType, list: [
                            default_testType,
                            gmk_testType,
                            ...(classSubject === '국어' ? [yigam_testType] : []),
                            etc_testType,
                        ], styles: { dropWrap: { flex: 1 } }, setDropValue: v => { setTestType(v); setSubTypeId(''); } }))),
            testType.id === 'etc' && (react_1.default.createElement("div", { className: "field-global-001" },
                react_1.default.createElement("div", { className: "task-label" }, t('assignment.subType')),
                react_1.default.createElement("div", { className: "fext-field" },
                    react_1.default.createElement(common_1.DropDown, { className: "dropdown-popup", value: subTypeId
                            ? (subTypesData?.items || []).find(s => s.id === subTypeId)
                                ? { id: subTypeId, title: (subTypesData?.items || []).find(s => s.id === subTypeId)?.title }
                                : { id: 'select', title: 'common.select' }
                            : { id: 'select', title: 'common.select' }, list: [
                            { id: 'select', title: 'common.select' },
                            ...((subTypesData?.items || [])
                                .filter(s => s.enabled)
                                .map(s => ({ id: s.id, title: s.title }))),
                        ], styles: { dropWrap: { flex: 1 } }, setDropValue: v => setSubTypeId(v.id === 'select' ? '' : v.id) }),
                    react_1.default.createElement(common_1.Button, { className: "", onClick: () => setShowSubTypeManager(true), option: { buttonBeforeIcon: { show: true, name: 'settings', size: 30 } } })))),
            testType.id !== 'select' && (react_1.default.createElement("div", { className: "field-global-001", style: { flexDirection: 'column' } },
                react_1.default.createElement("div", { className: "field-global-001" },
                    react_1.default.createElement("div", { className: "task-label" }, t('assignment.round')),
                    react_1.default.createElement("div", { className: "text-line" },
                        react_1.default.createElement(common_1.InputElement, { type: "number", min: 1, value: round, onChange: setRound }),
                        t('assignment.roundUnit'))),
                react_1.default.createElement("div", { className: "field-description" }, "* \uD68C\uCC28 \uC22B\uC790\uB97C \uC788\uB294 \uADF8\uB300\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694. (\uC608: 1\uD68C \u2192 1 / 10\uD68C \u2192 10)"))),
            testType.id === 'etc' && (react_1.default.createElement("div", { className: "field-global-001" },
                react_1.default.createElement("div", { className: "task-label" }, t('assignment.gradeReport')),
                react_1.default.createElement("div", { className: "fext-field" },
                    react_1.default.createElement(common_1.CheckBox, { isRadioButton: true, defaultCheckId: gradeReport ? 'include' : 'exclude', list: [
                            { id: 'include', title: 'assignment.includeGradeReport', checked: false },
                            { id: 'exclude', title: 'assignment.excludeGradeReport', checked: false },
                        ], handlerCheck: id => setGradeReport(id === 'include'), iconSize: 20 })))))),
        isTest ? (!isDesktop && isTeacher ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "field-global-001" },
                react_1.default.createElement("div", { className: "task-label" }, t('assignment.duration')),
                react_1.default.createElement("div", { className: "text-line" },
                    react_1.default.createElement(common_1.InputElement, { type: "number", min: 0, value: duration, onChange: setDuration }),
                    t('assignment.minute'))))) : (react_1.default.createElement("div", { className: "field-short ", style: {
                flex: isTablet && 'unset',
                flexDirection: isMobile && isLive ? 'column' : 'row',
            } },
            react_1.default.createElement("div", { className: "field-global-001" },
                react_1.default.createElement("div", { className: "task-label" }, t('assignment.duration')),
                react_1.default.createElement("div", { className: "text-line" },
                    react_1.default.createElement(common_1.InputElement, { type: "number", min: 0, value: duration, onChange: setDuration }),
                    t('assignment.minute')))))) : (!isBackOffice && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(DSTP001_Regist_Child_1.StartDate, { startDate: startDate, startTime: startTime, setStartDate: setStartDate, setStartTime: setStartTime, updateStartNow: updateStartNow }),
            react_1.default.createElement(DSTP001_Regist_Child_1.EndDate, { endDate: endDate, endTime: endTime, setEndDate: setEndDate, setEndTime: setEndTime })))))), [classId, className, duration, assignmentName, testType, round, gradeReport, subTypeId, subject, subTypesData, startDate, startTime, endDate, endTime, questionType]);
    /**
     * Render 출제 유형
     */
    const renderQuestionType = (0, react_1.useMemo)(() => isSurvey ? null : (react_1.default.createElement(DSTP001_Regist_Child_1.QuestionType, { key: "questionType", questionType: questionType, setQuestionType: setQuestionType, setSubject: setSubject, isModify: isModify || fromBackOffice, 
        // '설문조사' 출제유형은 강의 등록(예약 테스트 설정) 컨텍스트에서만 노출
        allowSurvey: isReserve && !isBackOffice })), [isSurvey, questionType, isModify, fromBackOffice, isReserve, isBackOffice]);
    /**
     * Render 과목 선택
     */
    const renderSubjectType = (0, react_1.useMemo)(() => (react_1.default.createElement(DSTP001_Regist_Child_1.SubjectType, { key: "subjectType", questionTypeId: questionType?.id, subject: subject, setSubject: setSubject })), [questionType, subject, isModify, fromBackOffice]);
    /**
     * Render
     * OMR 기본형 - 과목 상세 정보
     * OMR 자유형 - 평가 항목 개수
     * OMR 기본형, OMR 자유형, 파일첨부형 - 첨부파일
     */
    const renderSubjectInfo = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { key: "subjectInfo", className: "subject-info-wrap" },
        !isSurvey && questionType.id !== 'select' && questionType.id !== 'OMR' && questionType.id !== 'survey-poll' && (!isTest || testType.id === 'etc') && (react_1.default.createElement("div", { className: "field-global-001" },
            react_1.default.createElement("div", { className: "task-label" }, t('assignment.subjectFieldName')),
            react_1.default.createElement("div", { className: "fext-field" },
                react_1.default.createElement(common_1.InputElement, { type: "text", value: reportName, onChange: setReportName, placeholder: t('assignment.subjectFieldNamePlaceholder') })))),
        questionType.id === 'OMR' && (react_1.default.createElement(react_1.default.Fragment, null,
            ((isPopup && isMobile) || !isPopup) && renderSubjectType,
            react_1.default.createElement(DSTP001_Regist_Child_1.SubjectTypeDetail, { checkSubjectList: checkSubjectList, questionTypeId: questionType?.id, originalSubjectId: originalSubject?.id, subjectId: subject?.id, scoreBlank: scoreBlank, evalList: evalList, setEvalList: setEvalList, setScoreBlank: setScoreBlank }))),
        questionType.id === 'OMR-free' && (react_1.default.createElement(DSTP001_Regist_Child_1.EvaluationCount, { isReserve: isReserve, evalItemCnt: evalItemCnt, evalData: evalData, subjectId: subject?.id, setEvalItemCnt: setEvalItemCnt, setEvalData: setEvalData })),
        questionType.id !== 'select' && questionType.id !== 'attachment' && (react_1.default.createElement(DSTP001_Regist_Child_1.AttachFile, { isTeacher: isTeacher, showRegist: true, isRegist: true, isLive: isLive, attachFileList: attachFileList, setAttachFileList: setAttachFileList, isColumn: isTablet })))), [
        isReserve,
        id,
        questionType,
        subject,
        reportName,
        testType,
        originalSubject,
        scoreBlank,
        evalItemCnt,
        attachFileList,
        evalData,
        initEvalData,
        isModify,
        checkSubjectList,
        evalList,
        isPopup,
        isTeacher,
    ]);
    const handlerPreviousPage = () => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: 'list',
            id: undefined,
        });
        if (isBackOffice) {
            APP.eventManager.publish('CHANGE_MENU', {
                showDepth: 'list',
                props: {},
            });
        }
    };
    const cancelPopup = () => {
        APP.eventManager.publish('TOGGLE_POPUP');
    };
    /**
     * Render 평가 항목
     * OMR 기본형, OMR 자유형 - 평가 항목
     * 설문형 - 설문 항목
     */
    const renderTestItem = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { key: 'testItem', className: "test-item" },
        react_1.default.createElement("div", { className: "border-btm" },
            (questionType.id === 'OMR' || questionType.id === 'OMR-free') && (react_1.default.createElement(DSTP001_Regist_Child_1.ScoreContainer, { isDefault: questionType.id === 'OMR', subject: subject?.title, evalData: evalData, initEvalData: initEvalData, setEvalData: setEvalData, isModify: isModify || fromBackOffice, isPopup: isPopup })),
            ['survey', 'survey-poll'].includes(questionType.id) && (react_1.default.createElement(SurveyContainer_1.SurveyContainer, { questionId: questionType.id, item: item, test_id: item?.id, isRegist: true, handlerUpdateSurveyData: setSurveyData })),
            questionType.id === 'select' && !isPopup && (react_1.default.createElement("div", { className: "test-item-notice" },
                react_1.default.createElement(common_1.Icon, { icon: "arrow_in_circle_left", size: 42 }),
                react_1.default.createElement("p", null, "\uAC01 \uD56D\uBAA9\uBCC4\uB85C \uD544\uC694\uD55C \uC815\uBCF4\uB97C \uC791\uC131\uD574\uC8FC\uC138\uC694"))),
            questionType.id === 'attachment' && (react_1.default.createElement("div", { className: "test-item-attachment" },
                react_1.default.createElement(DSTP001_Regist_Child_1.AttachFile, { isTeacher: isTeacher, showRegist: true, isRegist: true, isLive: isLive, attachFileList: attachFileList, setAttachFileList: setAttachFileList, isColumn: true })))),
        !isMobile && !isPopup && (react_1.default.createElement("div", { className: "btn-container", style: { justifyContent: 'end' } },
            react_1.default.createElement(common_1.Button, { text: "common.cancel", className: "btn_white xmd", onClick: isPopup ? cancelPopup : handlerPreviousPage }),
            react_1.default.createElement(common_1.Button, { text: "common.okay", className: "btn_default xmd", onClick: e => submitAssignment() }))))), [
        questionType,
        subject,
        evalList,
        evalData,
        initEvalData,
        surveyData,
        isModify,
        fromBackOffice,
        item,
        attachFileList,
        submitAssignment,
        isPopup,
        isMobile,
        isTeacher,
    ]);
    const renderTitleInfo = (0, react_1.useMemo)(() => (react_1.default.createElement(layout_1.DetailTitleInfo, { title: isSurvey
            ? isModify
                ? '설문조사 수정'
                : '설문조사 등록'
            : isTest
                ? isModify
                    ? t('assignment.testModify')
                    : t('assignment.registTest')
                : isModify
                    ? t('assignment.modify')
                    : t('assignment.registAssignment'), previousPage: handlerPreviousPage })), [isSurvey, isTest, isModify]);
    // 상세 유형 관리 모달(중첩 오버레이) — 전역 PopupContainer(z-index:2) 위에 겹치게 렌더.
    // 닫기(X)는 이 오버레이만 닫고(등록 팝업은 그대로 유지) 상세유형 목록을 재조회한다.
    const renderSubTypeManagerModal = showSubTypeManager && (react_1.default.createElement("div", { className: `popup ${isDesktop ? 'desktop' : isTablet ? 'tablet' : 'mobile'}`, style: { zIndex: 10 } },
        react_1.default.createElement("div", { className: "popup-wrapper", style: { width: isMobile ? '90%' : 800, height: isMobile ? '90%' : 800, maxHeight: '90%' } },
            react_1.default.createElement("div", { className: "popup-header" },
                react_1.default.createElement("p", { className: "headline5" }, t('assignment.manageSubType')),
                react_1.default.createElement("div", { onClick: () => { setShowSubTypeManager(false); refetchSubTypes(); }, style: { cursor: 'pointer' } },
                    react_1.default.createElement(common_1.Icon, { icon: "close", size: 24, fill: "#ffffff" }))),
            react_1.default.createElement("div", { className: "popup-body" },
                react_1.default.createElement(TestSubTypeManager_1.TestSubTypeManager, { onClose: refetchSubTypes })))));
    if (!load)
        return null;
    if (isMobile) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            renderSubTypeManagerModal,
            react_1.default.createElement(DSTP001_Regist_Child_1.DSTP001Styled, { "$isTablet": isTablet, "$isMobile": isMobile || isReserve, "$isLive": isLive, "$isPopup": isPopup },
                react_1.default.createElement(layout_1.MobileTabLayout, { isTabMode: true, tabList: [
                        {
                            id: 1,
                            title: '기본정보',
                            component: [
                                renderAssignmentInfo,
                                ...(renderQuestionType ? [renderQuestionType] : []),
                                ...(['survey', 'survey-poll'].includes(questionType?.id) ? [renderSubjectInfo] : []),
                            ],
                            styles: {
                                gap: isTest ? '20px' : '12px',
                                display: 'flex',
                                flexDirection: 'column',
                            },
                        },
                        questionType && questionType.id == 'select'
                            ? null
                            : questionType &&
                                !['survey', 'survey-poll'].includes(questionType.id) &&
                                questionType.id !== 'attachment' && {
                                id: 2,
                                title: '과목',
                                component: [renderSubjectInfo],
                                styles: {
                                    gap: '12px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                },
                            },
                        questionType &&
                            subject && {
                            id: 3,
                            title: '평가항목',
                            component: [
                                react_1.default.createElement(react_1.Fragment, { key: "testItem" },
                                    react_1.default.createElement("div", { style: { display: 'none' } }, renderSubjectInfo),
                                    renderTestItem),
                            ],
                        },
                    ].filter(i => i), showNav: false, showPageButton: true, showPageTab: true, isSubmit: true, submitAssignment: submitAssignment, mobilePage: mobilePage, setMobilePage: setMobilePage, cancelPopup: isPopup && cancelPopup, isPopup: isPopup }))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        renderSubTypeManagerModal,
        react_1.default.createElement(DSTP001_Regist_Child_1.DSTP001Styled, { className: `dstp001_regist${isPopup ? '' : ' wrapper-padding'}`, "$isTablet": isTablet, "$isMobile": isMobile, "$isLive": isLive, "$isPopup": isPopup, "$isBackOffice": isBackOffice },
            react_1.default.createElement("div", { className: "task-info-container-wrapper", style: {
                    minHeight: (questionType.id === 'select' || questionType.id === 'attachment') &&
                        (isMobile ? 'auto' : 'unset'),
                } }, isPopup ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "task-info-container", style: { overflow: 'none' } },
                    renderAssignmentInfo,
                    react_1.default.createElement("div", { className: "field-short", style: {
                            flex: isTablet && 'unset',
                            flexDirection: isMobile && isLive ? 'column' : 'row',
                        } },
                        renderQuestionType,
                        !isMobile && renderSubjectType),
                    questionType.id !== 'select' && renderSubjectInfo,
                    isBackOffice && (react_1.default.createElement(PublicChoiceBox_1.PublicChoiceBox, { defaultHide: item?.status === 'hide' ? true : false, setHide: setHide }))),
                renderTestItem)) : (react_1.default.createElement(react_1.default.Fragment, null,
                !isBackOffice && isDesktop && renderTitleInfo,
                react_1.default.createElement("div", { className: "task-info" },
                    react_1.default.createElement("div", { className: "task-info-container" },
                        renderAssignmentInfo,
                        react_1.default.createElement("div", { className: "field-short", style: {
                                flex: isTablet && 'unset',
                                flexDirection: isMobile && isLive ? 'column' : 'row',
                            } }, renderQuestionType),
                        renderSubjectInfo,
                        isBackOffice && (react_1.default.createElement(PublicChoiceBox_1.PublicChoiceBox, { defaultHide: item?.status === 'hide' ? true : false, setHide: setHide }))),
                    renderTestItem)))),
            isPopup && (react_1.default.createElement("div", { className: "btn-container", style: { justifyContent: 'end' } },
                react_1.default.createElement(common_1.Button, { text: "common.cancel", className: "btn_white xmd", onClick: isPopup ? cancelPopup : handlerPreviousPage }),
                react_1.default.createElement(common_1.Button, { text: "common.okay", className: "btn_default xmd", onClick: e => submitAssignment() }))))));
});
